import { TextCodes } from '@api/types/translation/TextCodes';
import { Title, WarrantyPartFields, useWarrantyClaimContext } from '@components';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Box, IconButton } from '@mui/material';
import { t } from '@translations';

import { usePartsManager } from './usePartsManager';

export const WarrantyPartsSection = () => {
  const { addPart, fields, removePart } = usePartsManager();
  const { isReadOnly } = useWarrantyClaimContext();
  return (
    <>
      <Box display='flex' alignItems='center'>
        <Title noDot variant='h3' sx={{ mr: 2 }}>
          {t(TextCodes.Warranty.Block.Parts)}
        </Title>
        {!isReadOnly && (
          <IconButton onClick={addPart} color='success'>
            <AddCircleOutlineIcon />
          </IconButton>
        )}
      </Box>
      <WarrantyPartFields fields={fields} removePart={removePart} />
    </>
  );
};
